module.exports = __webpack_public_path__ + "img/cocar_100A.4f38c783.png";